import type { CapabilityChecker } from '@/features/authentication/types/permissions';
import { USER_MANAGEMENT_NAVIGATION } from '@/features/user-management/config/navigation';

/** Returns the first user-management workspace the caller may enter. */
export function defaultUserManagementRoute(
  hasCapability: CapabilityChecker,
): (typeof USER_MANAGEMENT_NAVIGATION)[number]['to'] | undefined {
  return USER_MANAGEMENT_NAVIGATION.find((item) => item.visibleWhen(hasCapability))?.to;
}
